var _desc, _defs, _g, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath0, _clipPath1, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21, _clipPath22, _clipPath23, _clipPath24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 607,
    height: 144,
    viewBox: "0 0 607 144",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "28360039-c5a4-4883-8a42-2748b50f857d"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "394946ff-7c67-4be5-b84e-19f38cfd911a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.82 0 0 1.82 423.69 547.85)",
    clipPath: "url(#CLIPPATH_36)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_36"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 109.95 1.15)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-193.85, -71)",
    d: "M 193.8 2.1 L 193.8 2.1 C 198.20000000000002 2.1 201.8 5.7 201.8 10.1 L 201.8 139.9 L 185.9 139.9 L 185.9 10.1 C 185.8 5.7 189.4 2.1 193.8 2.1",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.82 0 0 1.82 374.12 566.41)",
    clipPath: "url(#CLIPPATH_37)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_37"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 137.25 -9.1)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-166.55, -81.25)",
    d: "M 166.5 22.6 L 166.5 22.6 C 170.9 22.6 174.5 26.200000000000003 174.5 30.6 L 174.5 139.9 L 158.6 139.9 L 158.6 30.5 C 158.5 26.1 162.1 22.6 166.5 22.6",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.82 0 0 1.82 324.55 614.32)",
    clipPath: "url(#CLIPPATH_38)"
  }, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_38"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 164.55 -35.55)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-139.25, -107.7)",
    d: "M 139.2 75.5 L 139.2 75.5 C 143.6 75.5 147.2 79.1 147.2 83.5 L 147.2 139.9 L 131.29999999999998 139.9 L 131.29999999999998 83.4 C 131.3 79.1 134.9 75.5 139.2 75.5",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.82 0 0 1.82 1130.68 614.06)",
    clipPath: "url(#CLIPPATH_39)"
  }, _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_39"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -279.4 -35.4)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-583.2, -107.55)",
    d: "M 561.2 75.7 L 561.2 140.4 L 570 140.4 L 570 103.60000000000001 C 570 91.80000000000001 578.9 83.30000000000001 590 83.20000000000002 C 594.2 83.20000000000002 597.9 84.40000000000002 601.1 86.60000000000002 L 605.2 79.30000000000003 C 600.5 76.00000000000003 596.4000000000001 74.70000000000003 590.5 74.70000000000003 C 582.8 74.70000000000003 574.1 77.70000000000003 569.9 86.40000000000003 L 569.4 75.80000000000004 L 561.2 75.80000000000004 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.82 0 0 1.82 1016.49 614.96)",
    clipPath: "url(#CLIPPATH_40)"
  }, _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_40"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -216.48 -35.9)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-520.28, -108.05)",
    d: "M 496.5 104.2 C 498.2 90.2 507.8 82.30000000000001 520.7 82.30000000000001 C 533.7 82.30000000000001 544.3000000000001 90.00000000000001 544.5 104.20000000000002 L 496.5 104.20000000000002 z M 552.8 111.7 C 555.3 86.2 539.8 74.5 520.5999999999999 74.5 C 501.2999999999999 74.5 487.4999999999999 88.5 487.4999999999999 107.9 C 487.4999999999999 128.6 501.7999999999999 141.60000000000002 520.9999999999999 141.60000000000002 C 531.1999999999999 141.60000000000002 542.2999999999998 137.50000000000003 548.7999999999998 129.60000000000002 L 542.8999999999999 124.40000000000002 C 538.2999999999998 130.20000000000002 528.8999999999999 133.3 520.9999999999999 133.3 C 508.1999999999999 133.3 497.6999999999999 125.30000000000001 496.4999999999999 111.80000000000001 L 552.8 111.80000000000001 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.82 0 0 1.82 887.42 614.06)",
    clipPath: "url(#CLIPPATH_41)"
  }, _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_41"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -145.4 -35.4)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-449.2, -107.55)",
    d: "M 479.2 140.4 L 479.2 104 C 479.2 84.6 467.2 74.7 450.4 74.7 C 441.59999999999997 74.7 433.2 78.4 427.9 86.60000000000001 L 427.59999999999997 75.7 L 419.2 75.7 L 419.2 140.4 L 428 140.4 L 428 105.2 C 428 92.8 436.6 83.1 449.2 82.9 C 462.2 82.9 470.3 90.2 470.3 104.10000000000001 L 470.3 140.4 L 479.2 140.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.82 0 0 1.82 800.88 614.69)",
    clipPath: "url(#CLIPPATH_42)"
  }, _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_42"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -97.8 -35.75)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -4.4,
    y: -32.5,
    rx: 0,
    ry: 0,
    width: 8.8,
    height: 65
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.82 0 0 1.82 247.39 593.13)",
    clipPath: "url(#CLIPPATH_43)"
  }, _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_43"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 207.1 -23.85)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "-30.2,-43.9 -30.2,43.9 -14.2,43.9 -14.2,14.7 11,43.9 30.2,43.9 30.2,42.7 0.2,9.8 26.5,-19.6 26.5,-20.5 7.4,-20.5 -14.2,5.3 -14.2,-43.9 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.82 0 0 1.82 128.55 614.88)",
    clipPath: "url(#CLIPPATH_44)"
  }, _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_44"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 272.55 -35.85)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-31.25, -108)",
    d: "M 56.9 82.2 C 49.5 75.7 41.9 73.7 31.799999999999997 73.7 C 20 73.8 4.6 79 4.6 93.9 C 4.6 108.5 19.1 113 31.299999999999997 113.9 C 40.4 114.4 44.099999999999994 116.9 44.099999999999994 121.30000000000001 C 44.099999999999994 126.00000000000001 38.49999999999999 128.5 32.49999999999999 128.4 C 25.299999999999994 128.3 16.39999999999999 125.80000000000001 10.299999999999994 119.4 L 2.499999999999994 130.8 C 11.899999999999995 140.60000000000002 22.099999999999994 142.3 32.3 142.3 C 50.699999999999996 142.3 60 132.5 60 121.10000000000001 C 60 104 44.6 101.20000000000002 32.4 100.5 C 24.2 100 20.4 97.6 20.4 93.4 C 20.4 89.30000000000001 24.599999999999998 87 32.2 87 C 38.300000000000004 87 43.6 88.4 48.1 92.7 L 56.9 82.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.82 0 0 1.82 672.08 613.87)",
    clipPath: "url(#CLIPPATH_45)"
  }, _clipPath0 || (_clipPath0 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_45"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -26.75 -35.3)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-330.55, -107.45)",
    d: "M 335 140.4 L 335 103 C 335 91.6 342.7 82.8 354.1 82.8 C 365.5 82.8 372.70000000000005 91.2 372.70000000000005 102.69999999999999 L 372.70000000000005 140.39999999999998 L 381.50000000000006 140.39999999999998 L 381.50000000000006 102.69999999999997 C 381.50000000000006 85.69999999999997 370.80000000000007 74.49999999999997 354.30000000000007 74.49999999999997 C 344.70000000000005 74.49999999999997 335.30000000000007 79.19999999999997 331.00000000000006 89.39999999999998 C 327.20000000000005 78.49999999999997 317.50000000000006 74.49999999999997 308.20000000000005 74.49999999999997 C 300.30000000000007 74.49999999999997 292.40000000000003 77.59999999999997 288.20000000000005 85.79999999999997 L 287.80000000000007 75.69999999999997 L 279.6000000000001 75.69999999999997 L 279.6000000000001 140.39999999999998 L 288.4000000000001 140.39999999999998 L 288.4000000000001 102.99999999999997 C 288.4000000000001 91.59999999999997 296.0000000000001 82.79999999999997 307.4000000000001 82.79999999999997 C 318.80000000000007 82.79999999999997 326.4000000000001 91.59999999999997 326.4000000000001 102.99999999999997 L 326.4000000000001 140.39999999999998 L 335 140.39999999999998 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.82 0 0 1.82 825.75 476.41)",
    clipPath: "url(#CLIPPATH_46)"
  }, _clipPath1 || (_clipPath1 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_46"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -111.45 40.4)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,102,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-415.25, -31.75)",
    d: "M 401.6 43 C 396.5 43 392.40000000000003 47.1 392.40000000000003 52.2 C 392.40000000000003 57.300000000000004 396.50000000000006 61.400000000000006 401.6 61.400000000000006 C 406.70000000000005 61.400000000000006 410.8 57.300000000000004 410.8 52.2 C 410.8 50.900000000000006 410.5 49.6 410 48.5 L 423.9 36.8 C 425.29999999999995 37.699999999999996 427.09999999999997 38.3 428.9 38.3 C 434 38.3 438.09999999999997 34.199999999999996 438.09999999999997 29.099999999999998 C 438.09999999999997 24 433.99999999999994 19.9 428.9 19.9 C 427 19.9 425.29999999999995 20.4 423.9 21.4 L 416.29999999999995 14.999999999999998 C 416.79999999999995 13.899999999999999 417.09999999999997 12.599999999999998 417.09999999999997 11.299999999999997 C 417.09999999999997 6.1999999999999975 412.99999999999994 2.099999999999998 407.9 2.099999999999998 C 402.79999999999995 2.099999999999998 398.7 6.1999999999999975 398.7 11.299999999999997 C 398.7 16.4 402.8 20.499999999999996 407.9 20.499999999999996 C 409.79999999999995 20.499999999999996 411.5 19.899999999999995 412.9 18.999999999999996 L 420.5 25.4 C 420 26.5 419.7 27.799999999999997 419.7 29.099999999999998 C 419.7 30.4 420 31.7 420.5 32.8 L 406.6 44.5 C 405.2 43.5 403.4 43 401.6 43",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.82 0 0 1.82 324.46 513.27)",
    clipPath: "url(#CLIPPATH_47)"
  }, _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_47"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 164.6 20.05)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,102,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-139.2, -52.1)",
    d: "M 148.4 52.1 C 148.4 57.2 144.3 61.3 139.20000000000002 61.3 C 134.10000000000002 61.3 130.00000000000003 57.199999999999996 130.00000000000003 52.099999999999994 C 130.00000000000003 46.99999999999999 134.10000000000002 42.89999999999999 139.20000000000002 42.89999999999999 C 144.3 42.89999999999999 148.4 47.1 148.4 52.1",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.82 0 0 1.82 509.27 613.59)",
    clipPath: "url(#CLIPPATH_48)"
  }, _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_48"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 272.55 -35.85)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-31.25, -108)",
    d: "M 56.9 82.2 C 49.5 75.7 41.9 73.7 31.799999999999997 73.7 C 20 73.8 4.6 79 4.6 93.9 C 4.6 108.5 19.1 113 31.299999999999997 113.9 C 40.4 114.4 44.099999999999994 116.9 44.099999999999994 121.30000000000001 C 44.099999999999994 126.00000000000001 38.49999999999999 128.5 32.49999999999999 128.4 C 25.299999999999994 128.3 16.39999999999999 125.80000000000001 10.299999999999994 119.4 L 2.499999999999994 130.8 C 11.899999999999995 140.60000000000002 22.099999999999994 142.3 32.3 142.3 C 50.699999999999996 142.3 60 132.5 60 121.10000000000001 C 60 104 44.6 101.20000000000002 32.4 100.5 C 24.2 100 20.4 97.6 20.4 93.4 C 20.4 89.30000000000001 24.599999999999998 87 32.2 87 C 38.300000000000004 87 43.6 88.4 48.1 92.7 L 56.9 82.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 193.5 70.8)",
    clipPath: "url(#CLIPPATH_49)"
  }, _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_49"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 109.95 1.15)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-193.85, -71)",
    d: "M 193.8 2.1 L 193.8 2.1 C 198.20000000000002 2.1 201.8 5.7 201.8 10.1 L 201.8 139.9 L 185.9 139.9 L 185.9 10.1 C 185.8 5.7 189.4 2.1 193.8 2.1",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 166.2 81.05)",
    clipPath: "url(#CLIPPATH_50)"
  }, _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_50"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 137.25 -9.1)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-166.55, -81.25)",
    d: "M 166.5 22.6 L 166.5 22.6 C 170.9 22.6 174.5 26.200000000000003 174.5 30.6 L 174.5 139.9 L 158.6 139.9 L 158.6 30.5 C 158.5 26.1 162.1 22.6 166.5 22.6",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 138.9 107.5)",
    clipPath: "url(#CLIPPATH_51)"
  }, _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_51"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 164.55 -35.55)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-139.25, -107.7)",
    d: "M 139.2 75.5 L 139.2 75.5 C 143.6 75.5 147.2 79.1 147.2 83.5 L 147.2 139.9 L 131.29999999999998 139.9 L 131.29999999999998 83.4 C 131.3 79.1 134.9 75.5 139.2 75.5",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 582.85 107.35)",
    clipPath: "url(#CLIPPATH_52)"
  }, _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_52"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -279.4 -35.4)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-583.2, -107.55)",
    d: "M 561.2 75.7 L 561.2 140.4 L 570 140.4 L 570 103.60000000000001 C 570 91.80000000000001 578.9 83.30000000000001 590 83.20000000000002 C 594.2 83.20000000000002 597.9 84.40000000000002 601.1 86.60000000000002 L 605.2 79.30000000000003 C 600.5 76.00000000000003 596.4000000000001 74.70000000000003 590.5 74.70000000000003 C 582.8 74.70000000000003 574.1 77.70000000000003 569.9 86.40000000000003 L 569.4 75.80000000000004 L 561.2 75.80000000000004 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 519.93 107.85)",
    clipPath: "url(#CLIPPATH_53)"
  }, _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_53"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -216.48 -35.9)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-520.28, -108.05)",
    d: "M 496.5 104.2 C 498.2 90.2 507.8 82.30000000000001 520.7 82.30000000000001 C 533.7 82.30000000000001 544.3000000000001 90.00000000000001 544.5 104.20000000000002 L 496.5 104.20000000000002 z M 552.8 111.7 C 555.3 86.2 539.8 74.5 520.5999999999999 74.5 C 501.2999999999999 74.5 487.4999999999999 88.5 487.4999999999999 107.9 C 487.4999999999999 128.6 501.7999999999999 141.60000000000002 520.9999999999999 141.60000000000002 C 531.1999999999999 141.60000000000002 542.2999999999998 137.50000000000003 548.7999999999998 129.60000000000002 L 542.8999999999999 124.40000000000002 C 538.2999999999998 130.20000000000002 528.8999999999999 133.3 520.9999999999999 133.3 C 508.1999999999999 133.3 497.6999999999999 125.30000000000001 496.4999999999999 111.80000000000001 L 552.8 111.80000000000001 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 448.85 107.35)",
    clipPath: "url(#CLIPPATH_54)"
  }, _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_54"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -145.4 -35.4)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-449.2, -107.55)",
    d: "M 479.2 140.4 L 479.2 104 C 479.2 84.6 467.2 74.7 450.4 74.7 C 441.59999999999997 74.7 433.2 78.4 427.9 86.60000000000001 L 427.59999999999997 75.7 L 419.2 75.7 L 419.2 140.4 L 428 140.4 L 428 105.2 C 428 92.8 436.6 83.1 449.2 82.9 C 462.2 82.9 470.3 90.2 470.3 104.10000000000001 L 470.3 140.4 L 479.2 140.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 401.25 107.7)",
    clipPath: "url(#CLIPPATH_55)"
  }, _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_55"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -97.8 -35.75)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -4.4,
    y: -32.5,
    rx: 0,
    ry: 0,
    width: 8.8,
    height: 65
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 96.35 95.8)",
    clipPath: "url(#CLIPPATH_56)"
  }, _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_56"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 207.1 -23.85)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "-30.2,-43.9 -30.2,43.9 -14.2,43.9 -14.2,14.7 11,43.9 30.2,43.9 30.2,42.7 0.2,9.8 26.5,-19.6 26.5,-20.5 7.4,-20.5 -14.2,5.3 -14.2,-43.9 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 30.9 107.8)",
    clipPath: "url(#CLIPPATH_57)"
  }, _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_57"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 272.55 -35.85)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-31.25, -108)",
    d: "M 56.9 82.2 C 49.5 75.7 41.9 73.7 31.799999999999997 73.7 C 20 73.8 4.6 79 4.6 93.9 C 4.6 108.5 19.1 113 31.299999999999997 113.9 C 40.4 114.4 44.099999999999994 116.9 44.099999999999994 121.30000000000001 C 44.099999999999994 126.00000000000001 38.49999999999999 128.5 32.49999999999999 128.4 C 25.299999999999994 128.3 16.39999999999999 125.80000000000001 10.299999999999994 119.4 L 2.499999999999994 130.8 C 11.899999999999995 140.60000000000002 22.099999999999994 142.3 32.3 142.3 C 50.699999999999996 142.3 60 132.5 60 121.10000000000001 C 60 104 44.6 101.20000000000002 32.4 100.5 C 24.2 100 20.4 97.6 20.4 93.4 C 20.4 89.30000000000001 24.599999999999998 87 32.2 87 C 38.300000000000004 87 43.6 88.4 48.1 92.7 L 56.9 82.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 330.2 107.25)",
    clipPath: "url(#CLIPPATH_58)"
  }, _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_58"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -26.75 -35.3)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-330.55, -107.45)",
    d: "M 335 140.4 L 335 103 C 335 91.6 342.7 82.8 354.1 82.8 C 365.5 82.8 372.70000000000005 91.2 372.70000000000005 102.69999999999999 L 372.70000000000005 140.39999999999998 L 381.50000000000006 140.39999999999998 L 381.50000000000006 102.69999999999997 C 381.50000000000006 85.69999999999997 370.80000000000007 74.49999999999997 354.30000000000007 74.49999999999997 C 344.70000000000005 74.49999999999997 335.30000000000007 79.19999999999997 331.00000000000006 89.39999999999998 C 327.20000000000005 78.49999999999997 317.50000000000006 74.49999999999997 308.20000000000005 74.49999999999997 C 300.30000000000007 74.49999999999997 292.40000000000003 77.59999999999997 288.20000000000005 85.79999999999997 L 287.80000000000007 75.69999999999997 L 279.6000000000001 75.69999999999997 L 279.6000000000001 140.39999999999998 L 288.4000000000001 140.39999999999998 L 288.4000000000001 102.99999999999997 C 288.4000000000001 91.59999999999997 296.0000000000001 82.79999999999997 307.4000000000001 82.79999999999997 C 318.80000000000007 82.79999999999997 326.4000000000001 91.59999999999997 326.4000000000001 102.99999999999997 L 326.4000000000001 140.39999999999998 L 335 140.39999999999998 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 414.9 31.55)",
    clipPath: "url(#CLIPPATH_59)"
  }, _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_59"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 -111.45 40.4)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,102,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-415.25, -31.75)",
    d: "M 401.6 43 C 396.5 43 392.40000000000003 47.1 392.40000000000003 52.2 C 392.40000000000003 57.300000000000004 396.50000000000006 61.400000000000006 401.6 61.400000000000006 C 406.70000000000005 61.400000000000006 410.8 57.300000000000004 410.8 52.2 C 410.8 50.900000000000006 410.5 49.6 410 48.5 L 423.9 36.8 C 425.29999999999995 37.699999999999996 427.09999999999997 38.3 428.9 38.3 C 434 38.3 438.09999999999997 34.199999999999996 438.09999999999997 29.099999999999998 C 438.09999999999997 24 433.99999999999994 19.9 428.9 19.9 C 427 19.9 425.29999999999995 20.4 423.9 21.4 L 416.29999999999995 14.999999999999998 C 416.79999999999995 13.899999999999999 417.09999999999997 12.599999999999998 417.09999999999997 11.299999999999997 C 417.09999999999997 6.1999999999999975 412.99999999999994 2.099999999999998 407.9 2.099999999999998 C 402.79999999999995 2.099999999999998 398.7 6.1999999999999975 398.7 11.299999999999997 C 398.7 16.4 402.8 20.499999999999996 407.9 20.499999999999996 C 409.79999999999995 20.499999999999996 411.5 19.899999999999995 412.9 18.999999999999996 L 420.5 25.4 C 420 26.5 419.7 27.799999999999997 419.7 29.099999999999998 C 419.7 30.4 420 31.7 420.5 32.8 L 406.6 44.5 C 405.2 43.5 403.4 43 401.6 43",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 138.85 51.9)",
    clipPath: "url(#CLIPPATH_60)"
  }, _clipPath23 || (_clipPath23 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_60"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 164.6 20.05)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,102,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-139.2, -52.1)",
    d: "M 148.4 52.1 C 148.4 57.2 144.3 61.3 139.20000000000002 61.3 C 134.10000000000002 61.3 130.00000000000003 57.199999999999996 130.00000000000003 52.099999999999994 C 130.00000000000003 46.99999999999999 134.10000000000002 42.89999999999999 139.20000000000002 42.89999999999999 C 144.3 42.89999999999999 148.4 47.1 148.4 52.1",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 239.9 106.8)",
    clipPath: "url(#CLIPPATH_61)"
  }, _clipPath24 || (_clipPath24 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_61"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 272.55 -35.85)",
    id: "SVGID_2_",
    x: -303.8,
    y: -72.15,
    rx: 0,
    ry: 0,
    width: 607.6,
    height: 144.3
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-31.25, -108)",
    d: "M 56.9 82.2 C 49.5 75.7 41.9 73.7 31.799999999999997 73.7 C 20 73.8 4.6 79 4.6 93.9 C 4.6 108.5 19.1 113 31.299999999999997 113.9 C 40.4 114.4 44.099999999999994 116.9 44.099999999999994 121.30000000000001 C 44.099999999999994 126.00000000000001 38.49999999999999 128.5 32.49999999999999 128.4 C 25.299999999999994 128.3 16.39999999999999 125.80000000000001 10.299999999999994 119.4 L 2.499999999999994 130.8 C 11.899999999999995 140.60000000000002 22.099999999999994 142.3 32.3 142.3 C 50.699999999999996 142.3 60 132.5 60 121.10000000000001 C 60 104 44.6 101.20000000000002 32.4 100.5 C 24.2 100 20.4 97.6 20.4 93.4 C 20.4 89.30000000000001 24.599999999999998 87 32.2 87 C 38.300000000000004 87 43.6 88.4 48.1 92.7 L 56.9 82.2 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmLogo);
export default __webpack_public_path__ + "static/media/smLogo.8e8fed35843dd98c9296193437bf557d.svg";
export { ForwardRef as ReactComponent };